// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.try {
  margin-top: 65px;
  padding-bottom: 35px;
  margin-bottom: 110px;
}

.try__container {
  width: 100%;
  margin: 0 auto;
  max-width: 1100px;
  height: 100%;
  flex-direction: column;
  display: flex;

  @media screen and (max-width: 600px) {
    padding-top: 80px;
  }
}

.try__title {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 47px;
  text-align: center;
}

.try__text {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 30px;
  text-align: center;
}

.try__input {
  margin-top: 12px;
  display: flex;
  width: 100%;
  position: relative;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.try__search {
  display: flex;
  box-sizing: border-box;
  border: 1px solid #979797;
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  width: 100%;
  padding: 12px 24px;

  @media screen and (max-width: 600px) {
    height: 50px;
  }
}

.try__search::placeholder {
  color: #8D8D8D;
  font-family: Roboto;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
}

.try__search:focus {
  outline: none;
}

.try__button {
  display: flex;
  background-color: #9f9594;
  height: 38px;
  color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
  border: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  min-width: 175px;

  @media screen and (max-width: 600px) {
    margin-left: 0;
    margin-top: 20px;
  }
}

.try__button:hover {
  background-color: #8e7c7a;
}

.try__button img {
  margin-right: 11px;
}

.try__button svg {
  margin: 0 11px;
}

.try__btn-wrap {
  display: flex;
  justify-content: center;
  width: 33%;
}

@media screen and (max-width: 600px) {
  .try__btn-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.try__result {
  margin-top: 24px;
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  text-align: left;
}

.try__btn {
  display: flex;
  justify-content: center;
}

.try__show {
  height: 36px;
  width: 242px;
  background-color: #1e1c1a;
  color: #ffffff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  border: none;
  margin-top: 35px;
}

.try__btn-example {
  color: #3445d5;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
}

.try__btn__buttons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 15px;
}

.try__btn_label {
  color: #fa3329;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
  width: 30%;
  text-align: center;
  height: 25px;
  cursor: pointer;
}

.hide {
  display: none;
}

.try__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 20px 0;
}

.try__checkbox {
  margin-right: 12px;
  width: 16px;
  height: 16px;
}

.try__btn_summarize {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #fa3329;
  padding: 5px;
  color: white;
  border-radius: 8px;
  cursor: pointer;
}

.try__btn_summarize:hover {
  background-color: #e4281e;
}`, "",{"version":3,"sources":["webpack://./src/components/TryIt/TryIt.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,aAAa;;EAEb;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,kBAAkB;;EAElB;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;;EAElB;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;;EAEhB;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".try {\n  margin-top: 65px;\n  padding-bottom: 35px;\n  margin-bottom: 110px;\n}\n\n.try__container {\n  width: 100%;\n  margin: 0 auto;\n  max-width: 1100px;\n  height: 100%;\n  flex-direction: column;\n  display: flex;\n\n  @media screen and (max-width: 600px) {\n    padding-top: 80px;\n  }\n}\n\n.try__title {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 47px;\n  text-align: center;\n}\n\n.try__text {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 30px;\n  text-align: center;\n}\n\n.try__input {\n  margin-top: 12px;\n  display: flex;\n  width: 100%;\n  position: relative;\n\n  @media screen and (max-width: 600px) {\n    flex-direction: column;\n  }\n}\n\n.try__search {\n  display: flex;\n  box-sizing: border-box;\n  border: 1px solid #979797;\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  width: 100%;\n  padding: 12px 24px;\n\n  @media screen and (max-width: 600px) {\n    height: 50px;\n  }\n}\n\n.try__search::placeholder {\n  color: #8D8D8D;\n  font-family: Roboto;\n  font-size: 18px;\n  letter-spacing: 0;\n  line-height: 24px;\n}\n\n.try__search:focus {\n  outline: none;\n}\n\n.try__button {\n  display: flex;\n  background-color: #9f9594;\n  height: 38px;\n  color: #ffffff;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 21px;\n  border: none;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 8px;\n  min-width: 175px;\n\n  @media screen and (max-width: 600px) {\n    margin-left: 0;\n    margin-top: 20px;\n  }\n}\n\n.try__button:hover {\n  background-color: #8e7c7a;\n}\n\n.try__button img {\n  margin-right: 11px;\n}\n\n.try__button svg {\n  margin: 0 11px;\n}\n\n.try__btn-wrap {\n  display: flex;\n  justify-content: center;\n  width: 33%;\n}\n\n@media screen and (max-width: 600px) {\n  .try__btn-wrap {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.try__result {\n  margin-top: 24px;\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 30px;\n  text-align: left;\n}\n\n.try__btn {\n  display: flex;\n  justify-content: center;\n}\n\n.try__show {\n  height: 36px;\n  width: 242px;\n  background-color: #1e1c1a;\n  color: #ffffff;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 16px;\n  border: none;\n  margin-top: 35px;\n}\n\n.try__btn-example {\n  color: #3445d5;\n  font-family: Roboto;\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 30px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.try__btn__buttons {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 0 15px;\n}\n\n.try__btn_label {\n  color: #fa3329;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 21px;\n  width: 30%;\n  text-align: center;\n  height: 25px;\n  cursor: pointer;\n}\n\n.hide {\n  display: none;\n}\n\n.try__actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 20px 0;\n}\n\n.try__checkbox {\n  margin-right: 12px;\n  width: 16px;\n  height: 16px;\n}\n\n.try__btn_summarize {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: #fa3329;\n  padding: 5px;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.try__btn_summarize:hover {\n  background-color: #e4281e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
